export default __webpack_public_path__ + "static/media/background.19da51c7.png";